import Axios from 'axios';

const RESOURCE = '/api/links';

export default {
  /**
   * Find Link by id
   * @param {string} job.id - Link Identifier
   */
  get(id) {
    return Axios.get(`${RESOURCE}/fetch/${id}`);
  },

  /**
   * Create job by guid
   * @param {string} job.guid - S3 Job Identifier
   */
  create() {
    return Axios.get(`${RESOURCE}/create`);
  },

  /**
   * Update wavve.link profile
   * TODO - should use PUT and :id
   * @param {object} data - wavve.link properties
   */
  update(data) {
    return Axios.post(`${RESOURCE}/update`, data);
  },

  /**
   * Set Shortlink
   * TODO - should use PUT and :id
   * @param {string} slug - wavve.link slug
   */
  setShortlink(slug) {
    return Axios.post(`${RESOURCE}/slug`, { slug });
  },
};
